import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createConsignation, getAllFranchises, getAllRepresentatives } from '../../../../../actions/inventoryActions'
import Button from '../../../../../utils/components/Button/Button'
import ImageNameDescription from '../../../../../utils/components/ImageNameDescription/ImageNameDescription'
import InputSearch from '../../../../../utils/components/InputSearch/InputSearch'

export const PaymentSummary = ({bag}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const [string, setString] = useState("")
    const [entity, setEntity] = useState(null)
    const { franchises, representatives } = useSelector(state => state.inventory)
    useEffect(() => {
        dispatch(getAllFranchises(string, 50, 0))
        dispatch(getAllRepresentatives(string, 50, 0))
        return () => {

        }
    }, [string])

    return (
        <div className='payment-summary'>


            <InputSearch placeholder='Digite una EcoTienda o un EcoMaster' searchData={v => setString(v)}
                renderData={
                    <>
                        {
                            franchises.map(franchise => (
                                <ImageNameDescription
                                    onClick={e => setEntity(franchise)}
                                    firstName={franchise.socialReason}
                                />
                            ))
                        }
                        {
                            representatives.map(representative => (
                                <ImageNameDescription
                                    onClick={e => setEntity(representative)}
                                    firstName={representative.name}
                                />
                            ))
                        }

                    </>

                }

            />
            {
                entity && <ImageNameDescription

                    firstName={entity.name ? entity.name : entity.socialReason}
                />
            }
            <Button
                text='Consignar'
                disabled={!entity}
                onClick={e=>{
                    dispatch(createConsignation(entity._id,bag,history))
                }}
            />
        </div>
    )
}
